<template>
  <div>
    <card>Reports avaialble in the system for download.</card>
    <div class="row justify-content-start">

      <div class="col-md-3">
        <ReportCard 
          image="https://cdn.webrezpro.com/wp-content/uploads/2019/09/customReport.jpg"
          category="KJC+ App - Students"
          title="Subscription Report"
          description="List of all students who have installed app."
          :showFooter="true"
          link="/glimpses/subscription/subscribers/all/students"
          ></ReportCard>
      </div>

      <div class="col-md-3">
        <ReportCard 
          image="https://cdn.webrezpro.com/wp-content/uploads/2019/09/customReport.jpg"
          category="KJC+ App - Students"
          title="Unsubscription Report"
          description="List of all students who have not installed app."
          :showFooter="true"
          link="/glimpses/subscription/unsubscribers/all/students"
          btnType="warning"
          ></ReportCard>
      </div>

      <div class="col-md-3">
        <ReportCard 
          image="https://cdn.webrezpro.com/wp-content/uploads/2019/09/customReport.jpg"
          category="KJC+ App - Teachers"
          title="Subscription Report"
          description="List of all teachers who have installed app."
          :showFooter="true"
          link="/glimpses/subscription/subscribers/all/teachers"
          ></ReportCard>
      </div>

      <div class="col-md-3">
        <ReportCard 
          image="https://cdn.webrezpro.com/wp-content/uploads/2019/09/customReport.jpg"
          category="KJC+ App - Teachers"
          title="Unsubscription Report"
          description="List of all teachers who have not installed app."
          :showFooter="true"
          link="/glimpses/subscription/unsubscribers/all/teachers"
          btnType="warning"
          ></ReportCard>
      </div>

    </div>
  </div>
</template>

<script>
import { Card, ReportCard } from "src/components";
import { mapGetters } from "vuex";

export default {
  components: {
    Card,
    ReportCard
  },
  mounted() {
    // this.$store.dispatch('getUserProgrammes')
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      // programmes: 'getProgrammes',
      preferences: "getPreferences"
      // registrations: 'getRegistrations'
    })
  },
  methods: {}
};
</script>

<style lang="scss">
</style>
